import {
  Filter,
  FilterClearBtn,
  FilterLabel,
  FilterOptionItem,
  FilterOptionsList,
  FilterPlaceholder,
  FilterTrigger,
  FilterValue,
} from '@src/design-system/filter';
import { getChannelSvg } from '@src/shared/features/reminders/helpers/get-channel-svg';
import { REMINDER_CHANNELS } from '@src/shared/types/reminder';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import type { TReminderTemplate } from '@src/shared/types/reminder-template';
import type { TTempFilters } from './';

export function ReminderChannelFilter({
  tempFilters,
  setTempFilters,
}: {
  tempFilters: TTempFilters;
  setTempFilters: (filters: TTempFilters) => void;
}) {
  return (
    <Filter
      multiple={false}
      value={tempFilters.channel}
      onValueChange={(value) =>
        setTempFilters({
          ...tempFilters,
          channel: value,
        })
      }
    >
      <div className='w-full flex items-center justify-between'>
        <FilterLabel>Channel</FilterLabel>
        <FilterClearBtn />
      </div>
      <FilterTrigger>
        <FilterPlaceholder>Select Channel</FilterPlaceholder>
        <FilterValue>
          {(value: TReminderTemplate['channel']) => (
            <div className='flex items-center gap-2'>
              <div className='size-4'>
                <img
                  src={getChannelSvg(value)}
                  alt={value}
                />
              </div>
              {formatTextForDisplay(value)}
            </div>
          )}
        </FilterValue>
      </FilterTrigger>
      <FilterOptionsList>
        {Object.values(REMINDER_CHANNELS).map((channel) => (
          <FilterOptionItem
            value={channel}
            key={channel}
          >
            <div className='size-4'>
              <img
                src={getChannelSvg(channel)}
                alt={channel}
              />
            </div>
            <span>{formatTextForDisplay(channel)}</span>
          </FilterOptionItem>
        ))}
      </FilterOptionsList>
    </Filter>
  );
}
